(() => {
  const FLAG = 'uviManualDiscount';
  const COOKIE_NAMES = ['discount_code', 'discount_code_copy'];

  const hasManualDiscount = () => {
    try {
      return Boolean(sessionStorage.getItem(FLAG));
    } catch (error) {
      return false;
    }
  };

  const setManualDiscount = (code) => {
    try {
      if (code) sessionStorage.setItem(FLAG, String(code));
      else sessionStorage.removeItem(FLAG);
    } catch (error) {
      /* ignore */
    }
  };

  const expireDiscountCookies = () => {
    const host = window.location.hostname.replace(/^www\./, '');
    const domains = ['', window.location.hostname, '.' + host];
    COOKIE_NAMES.forEach((name) => {
      domains.forEach((domain) => {
        let cookie = name + '=; Max-Age=0; path=/';
        if (domain) cookie += '; domain=' + domain;
        document.cookie = cookie;
      });
    });
  };

  const cartHasApplicableCode = (cart) => {
    return Boolean((cart?.discount_codes || []).some((item) => item && item.applicable && item.code));
  };

  const clearCartDiscount = async () => {
    expireDiscountCookies();
    const cartUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) || '/cart';
    const updateUrl = (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_update_url) || '/cart/update.js';
    const cart = await fetch(`${cartUrl}.js`, { credentials: 'same-origin' }).then((response) => response.json());
    if (!cartHasApplicableCode(cart)) return false;
    await fetch(updateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' }),
    });
    return true;
  };

  const stripDiscountParam = (url) => {
    try {
      const parsed = new URL(url, window.location.origin);
      if (!parsed.searchParams.has('discount')) return url;
      parsed.searchParams.delete('discount');
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return url;
    }
  };

  const isCheckoutUrl = (url) => {
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.pathname === '/checkout' || parsed.pathname.endsWith('/checkout');
    } catch (error) {
      return false;
    }
  };

  window.uviMarkManualDiscount = setManualDiscount;

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href || !isCheckoutUrl(href)) return;
      const cleaned = stripDiscountParam(href);
      if (cleaned !== href) link.setAttribute('href', cleaned);
      if (hasManualDiscount()) return;
      event.preventDefault();
      clearCartDiscount()
        .catch(() => {})
        .finally(() => {
          window.location.href = cleaned;
        });
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('is') === 'cart-discount') return;
      if (form.dataset.uviDiscountReady === '1') return;

      const submitter = event.submitter;
      const checkoutButton = submitter && submitter.getAttribute('name') === 'checkout';
      const action = form.getAttribute('action') || '';
      const goingToCheckout = checkoutButton || isCheckoutUrl(action);
      if (!goingToCheckout) return;
      if (hasManualDiscount()) return;

      event.preventDefault();
      event.stopPropagation();
      clearCartDiscount()
        .catch(() => {})
        .finally(() => {
          form.dataset.uviDiscountReady = '1';
          HTMLFormElement.prototype.submit.call(form);
        });
    },
    true
  );

  if (hasManualDiscount()) return;

  clearCartDiscount().catch(() => {});
})();
